import { getCurrentUser } from "@/services";
import { useQuery } from "@tanstack/react-query";

export const GET_USER_QUERY_KEY = "get-user";
export function useGetUser({ enabled = true }: { enabled?: boolean }) {
  return useQuery({
    queryKey: [GET_USER_QUERY_KEY],
    queryFn: async () => {
      const response = await getCurrentUser();
      return response?.data[0] ?? null;
    },
    retry: 0,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    // staleTime: 5 * 60 * 1000, // 5 minutes
    staleTime: 0, // 5 minutes
    enabled,
  });
}
